import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors, withXhr } from '@angular/common/http';
import { authInterceptor, unauthInterceptor, commsErrorInterceptor, accountGateInterceptor } from './auth';
import { provideAuth } from 'angular-auth-oidc-client';

import { routes } from './app.routes';
import { environment } from '../environments/environment';
import { lucideIconsProvider } from './shared/lucide-icons';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    lucideIconsProvider,
    provideHttpClient(
      withXhr(),
      // accountGateInterceptor is first so a blocked request short-circuits before
      // the auth/unauth/comms interceptors run (no token fetch, no 401 redirect).
      withInterceptors([accountGateInterceptor, authInterceptor, unauthInterceptor, commsErrorInterceptor]),
    ),
    provideAuth({
      config: {
        authority: environment.keycloakAuthority,
        redirectUrl: environment.keycloakRedirectUri,
        postLogoutRedirectUri: environment.keycloakPostLogoutUri,
        clientId: environment.keycloakClientId,
        scope: environment.keycloakScope,
        responseType: environment.keycloakResponseType,
        silentRenew: true,
        useRefreshToken: true,
        renewTimeBeforeTokenExpiresInSeconds: 30,
        secureRoutes: [],
      },
    }),
  ],
};
